// ErrorState — Presentational error banner shown when a search fails.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// and rendered content are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';

export const ErrorState = React.memo(function ErrorState({ error }) {
  return (
    <div style={{
      padding: '16px', backgroundColor: '#fef2f2',
      border: '1px solid #fecaca', borderRadius: '6px',
      color: '#991b1b', marginBottom: '20px'
    }}>
      {error}
    </div>
  );
});

export default ErrorState;
